import { Box, Button, Stack } from '@mui/material';
import { startOfMonth } from 'date-fns';
import { ReactNode } from 'react';
import { useForm } from 'react-hook-form';

import FormController from 'portal/src/components/common/forms/FormController';
import { datePickerType } from 'portal/src/components/common/forms/FormFieldTypes';
import GenericDialog from 'portal/src/components/common/GenericDialog';

const MonthPickerDialogForm = ({
  children,
  confirmLabel,
  defaultValue = null,
  fieldConf,
  formId,
  isLoading = false,
  maxWidth = 'sm',
  onClose,
  onSave,
  open,
  title,
}: {
  children?: ReactNode;
  confirmLabel: string;
  defaultValue?: Date | null;
  fieldConf: datePickerType;
  formId: string;
  isLoading?: boolean;
  maxWidth?: 'sm' | 'md';
  onClose: () => void;
  onSave: (month: Date) => void;
  open: boolean;
  title?: string;
}) => {
  const { control, handleSubmit } = useForm<Record<string, Date | null>>({
    defaultValues: { [fieldConf.name]: defaultValue },
  });

  const submitForm = (data: Record<string, Date | null>) =>
    onSave(startOfMonth(data[fieldConf.name] as Date));

  return (
    <GenericDialog
      title={title}
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      dialogActions={
        <Stack direction="row" spacing={2}>
          <Button variant="outlined" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            disableElevation
            onClick={handleSubmit(submitForm)}
            variant="contained"
            type="submit"
            form={formId}
            disabled={isLoading}
          >
            {confirmLabel}
          </Button>
        </Stack>
      }
    >
      {children}
      <form id={formId}>
        <Box mt={2}>
          <FormController control={control} fieldConf={fieldConf} />
        </Box>
      </form>
    </GenericDialog>
  );
};

export default MonthPickerDialogForm;
